<template>
  <div id="root" class="toggle-menu wrap">
    <menu-component></menu-component>
    <div class="home-header bg-img center-text">
      <b-container>
        <b-row>
          <b-col>
            <h1>Soluciones integrales para el campo</h1>
            <br />
            <span style="color:white;">Mejoramos la calidad de vida de los agricultores</span>
            <br /><br />
            <router-link to="/contacto">
              <b-button class="alinov" variant="primary">CONTÁCTANOS</b-button>
            </router-link>
            <br /><br />
            <a class="link-to-section" href="#impact">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div id="impact" class="icons-container gray-bg">
      <b-container class="alinov-container imgs center-text">
        <b-row>
          <b-col>
            <h2>
              Nuestro Impacto
            </h2>
            <span>
              Con nuestro esfuerzo hemos logrado muchos cambios
            </span>
          </b-col>
        </b-row>
       <b-row class="icons-row">
          <b-col sm="12" md="4">
           <i class="fas fa-leaf"></i>
            <p>
             Reducción de tiempo y costo en la agricultura y ganadería.
            </p>
          </b-col>
          <b-col sm="12" md="4">
            <i class="fas fa-user-alt"></i>
            <p>
             Crecimiento en la región valles con KOLECTIVA.
            </p>
          </b-col>
          <b-col sm="12" md="4">
            <i class="fas fa-bolt"></i>
            <p>
             Innovación el área agrícola implementando la tecnología en la región valles con la aplicación foliar por medio de drones.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="alinov-container info-container bg-img">
      <b-container>
        <b-row>
          <b-col sm="1" md="4">
          </b-col>
          <b-col sm="11" md="8">
            <h2></h2>
            <p>
            </p>
            <router-link to="/nosotros">
              <b-button class="alinov" variant="primary">Ver más</b-button>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from '../shared/Menu.vue';
import Footer from '../shared/Footer.vue';
import $ from 'jquery'

export default {
  name: 'Home',
  components: {
    'menu-component': Menu,
    'footer-component': Footer
  },
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
      });
    });

    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
      var headerHeight = $('.home-header').height() + 100;

      if (scroll >= headerHeight) {
          $(".toggle-menu  .alinov-navbar:not(#nav-mobile)").addClass("white-bg");
      } else {
        $(".toggle-menu  .alinov-navbar:not(#nav-mobile)").removeClass("white-bg");
      }
    });
  },
  mounted() {
    //$('h2').hide();
  },  
  methods: {
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    }
  }
};
</script>

<style lang="scss" scoped>

h2 {
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  transition: all 0.3s linear;
}

@media only screen and (max-width: 414px) {
  .home-header {
    padding-top: 160px;

    h1 {
      font-size: 32px;
    }

    span {
      font-size: 1.15rem;
    }
  }
}

@media only screen and (min-width: 415px) {
  .home-header {
    padding-top: 180px;

    h1 {
      font-size: 48px;
    }

    span {
      font-size: 1.3rem;
    }
  }
}
.home-header {
  background-image: linear-gradient( 
    rgba(0, 0, 0, 0.2), 
    rgba(0, 0, 0, 0.2) ),  
    url("../assets/images/agricultura.jpg");
  height: 670px;

  h1 {
    color: #FFFFFF
  }
}

.quotes-container {
  h1, .carousel-indicators li {
    color: #FFFFFF
  }
}

.info-container {
  background-image: linear-gradient( 
    rgba(0, 0, 0, 0.5), 
    rgba(0, 0, 0, 0.5) ),  
    url("../assets/images/agricultura1.jpg");
  margin: 0;
  color: #FFFFFF;
}

.icons-container {
  .fas, .img-fluid {
    font-size: 3rem;
    color: #007CC2;
    margin-bottom: 2rem;
  }

  .icons-row {
    margin-top: 3rem;
  }
}

.img-container {
  text-align: center;
}

.alinov-container.imgs .img-fluid {
    width: 60%;
}

.bottom-text-container {
  position: absolute;
  bottom: 0;
}

</style>

